"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useDebounce_1 = __importDefault(require("hooks/useDebounce"));
const useJira_1 = __importDefault(require("hooks/useJira"));
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const Switcher_1 = __importDefault(require("components/design-system/Switcher"));
const SearchBar_1 = __importDefault(require("components/shared/SearchBar"));
const ConfirmConnectJira_1 = __importDefault(require("./ConfirmConnectJira"));
const TableConnectJira_1 = __importDefault(require("./TableConnectJira"));
const ContentJira = ({ objectiveChildrenCount, modalType }) => {
    const stepModal = (0, useJira_1.default)((state) => state.stepModal);
    const selectedData = (0, useJira_1.default)((state) => state.selectedData);
    const setSelectedData = (0, useJira_1.default)((state) => state.setSelectedData);
    const [searchValue, setSearchValue] = (0, react_1.useState)('');
    const debounceSearchValue = (0, useDebounce_1.default)(searchValue, 500);
    const jiraList = (0, react_1.useMemo)(() => [
        { id: 'project', name: 'Project' },
        { id: 'issue', name: 'Issue' }
    ], []);
    return (react_1.default.createElement(Modal_1.default.Body, { maxHeight: 492 },
        react_1.default.createElement("div", { className: "mx-[24px] w-full" }, stepModal == 'choose-data' || stepModal == 'child-issues' ? (react_1.default.createElement(react_1.default.Fragment, null,
            stepModal == 'choose-data' && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Switcher_1.default, { options: jiraList, selectedOption: selectedData, onChange: (tab) => setSelectedData(tab), customClass: "mb-[12px]", textCustomClass: "typography-button" }),
                react_1.default.createElement(SearchBar_1.default, { fullWidth: true, onChange: (e) => setSearchValue(e?.target?.value), containerClass: "mb-[12px]" }))),
            react_1.default.createElement(TableConnectJira_1.default, { searchValue: debounceSearchValue, isShowChildIssue: modalType == 'import-child' || stepModal == 'child-issues' }))) : (react_1.default.createElement(ConfirmConnectJira_1.default, { objectiveChildrenCount: objectiveChildrenCount, modalType: modalType })))));
};
exports.default = ContentJira;
